import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link, Outlet } from 'react-router-dom'
import api, { operation } from '../../services/axios'
import * as actions from '../../store/modules/cerc/actions'
import { cercDeleteAllPayments } from '../../store/modules/cerc/actions'
import { StoreState } from '../../store'
import { Button, Typography } from '@mui/material'
import Dialog from '../../components/Dialog'
import { Container, DialogOptIn, Content } from './styles'
import { get } from 'lodash'
import { useOptIn } from '../../hooks/opt-in'

const MinhaConta: React.FC = () => {
    const { email, verificationC, cnpj_cpf } = useSelector(
        (state: StoreState) => state.auth.user
    )
    const { handleAcceptOptIn } = useOptIn()

    const [isTermsOptInOpen, setIsTermsOptInOpen] = useState(false)
    const [optInId, setOptInId] = useState(-1)

    useEffect(() => {
        async function getInfo() {
            operation.attempt(async (currentAttempt) => {
                try {
                    const { data } = await api.post(`/optin/info`, {
                        cnpj_cpf,
                    })
                    setOptInId(data.optInSubmitId)
                } catch (e: any) {
                    const status = get(e, 'response.status', '')
                    // toast.error(erro)
                    if (status === 401) {
                        if (operation.retry(e)) return
                    }
                }
            })
        }
        getInfo()
    }, [verificationC, cnpj_cpf])

    return (
        <Container>
            {!verificationC && (
                <DialogOptIn>
                    <h2>Olá, {email}</h2>
                    {/* <p>Parece que você ainda não aceitou os <Link onClick={() => setIsTermsOptInOpen(true)} to='#'>Termos do Opt In</Link></p> */}
                    <p>Parece que você ainda não aceitou os Termos do Opt In</p>
                    <p>
                        Clique em aceitar para continuar utilizando a plataforma
                        com todas as funcionalidades
                    </p>
                    <form onSubmit={handleAcceptOptIn} className="actions">
                        <Button variant="contained" type="submit">
                            Aceitar
                        </Button>
                    </form>
                </DialogOptIn>
            )}

            <h1>Configurações</h1>

            <div className="bar">
                <ul>
                    <li>
                        <Link to="instituicao">Instituição</Link>
                    </li>
                    <li>
                        <Link to="domicilio-pagamento">
                            Domicílio de pagamento
                        </Link>
                    </li>

                    <li>
                        <Link to="documentos">Documentos</Link>
                    </li>
                    {/* <li>
                        <Link to="instituicao">Perfil</Link>
                    </li> */}
                    <li>
                        <Link to="senha">Senha</Link>
                    </li>
                    {/* <li>
                        <Link to="instituicao">Usuários</Link>
                    </li> */}
                    {/* <li>
                        <Link to="instituicao">Notificações</Link>
                    </li> */}
                    <li>
                        <Link to="termos">Termos</Link>
                    </li>
                    {/* <li>
                        <Link to="instituicao">Integrações</Link>
                    </li> */}
                    <li>
                        <Link to="solicitacoes-de-acesso">Antecipações</Link>
                    </li>
                    {/* <li>
                        <Link to="instituicao">API</Link>
                    </li> */}
                </ul>
            </div>
            <Content>
                <Outlet />
            </Content>

            {/* <Dialog
                isTermsOpen={isTermsOptInOpen}
                setIsTermsOpen={setIsTermsOptInOpen}
                title="Termos de uso"
            >
                <Typography gutterBottom>
                    Cras mattis consectetur purus sit amet fermentum. Cras justo
                    odio, dapibus ac facilisis in, egestas eget quam. Morbi leo
                    risus, porta ac consectetur ac, vestibulum at eros. Cras
                    mattis consectetur purus sit amet fermentum. Cras justo
                    odio, dapibus ac facilisis in, egestas eget quam. Morbi leo
                    risus, porta ac consectetur ac, vestibulum at eros. Cras
                    mattis consectetur purus sit amet fermentum. Cras justo
                    odio, dapibus ac facilisis in, egestas eget quam. Morbi leo
                    risus, porta ac consectetur ac, vestibulum at eros. Cras
                    mattis consectetur purus sit amet fermentum. Cras justo
                    odio, dapibus ac facilisis in, egestas eget quam. Morbi leo
                    risus, porta ac consectetur ac, vestibulum at eros. Cras
                    mattis consectetur purus sit amet fermentum. Cras justo
                    odio, dapibus ac facilisis in, egestas eget quam. Morbi leo
                    risus, porta ac consectetur ac, vestibulum at eros.
                </Typography>
                <Typography gutterBottom>
                    Cras mattis consectetur purus sit amet fermentum. Cras justo
                    odio, dapibus ac facilisis in, egestas eget quam. Morbi leo
                    risus, porta ac consectetur ac, vestibulum at eros.
                </Typography>

                <Typography gutterBottom>
                    Cras mattis consectetur purus sit amet fermentum. Cras justo
                    odio, dapibus ac facilisis in, egestas eget quam. Morbi leo
                    risus, porta ac consectetur ac, vestibulum at eros.
                </Typography>

                <Typography gutterBottom>
                    Cras mattis consectetur purus sit amet fermentum. Cras justo
                    odio, dapibus ac facilisis in, egestas eget quam. Morbi leo
                    risus, porta ac consectetur ac, vestibulum at eros.
                </Typography>
                <Typography gutterBottom>
                    Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur et. Vivamus sagittis lacus vel augue laoreet
                    rutrum faucibus dolor auctor.
                </Typography>
                <Typography gutterBottom>
                    Aenean lacinia bibendum nulla sed consectetur. Praesent
                    commodo cursus magna, vel scelerisque nisl consectetur et.
                    Donec sed odio dui. Donec ullamcorper nulla non metus auctor
                    fringilla.
                </Typography>
            </Dialog> */}
        </Container>
    )
}

export default MinhaConta
